import { render, staticRenderFns } from "./adriftDetail.vue?vue&type=template&id=27b51300&scoped=true&"
import script from "./adriftDetail.vue?vue&type=script&lang=js&"
export * from "./adriftDetail.vue?vue&type=script&lang=js&"
import style0 from "./adriftDetail.vue?vue&type=style&index=0&id=27b51300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b51300",
  null
  
)

export default component.exports